class VoskHandlerManager {
  constructor() {
    if (VoskHandlerManager.instance) {
      return VoskHandlerManager.instance;
    }

    VoskHandlerManager.instance = this;
    this.captureMic = false;
    this.recognizer = null;
  }

  getPromptCleaned = (utterances) => {
    let prompt = "";
    utterances.forEach((utterance, index) => {
      if(utterance.text) {
        prompt += utterance.text;
        if (index < utterances.length - 1) {
          prompt += ", ";
        } else {
          prompt += " ";
        }
      }
    });
    return prompt;
  }

}

// Exporting a singleton instance
const voskManager = new VoskHandlerManager();

export default voskManager;